<template lang="html">
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
    version="1.1"
    id="mannequin-icon"
    x="0px"
    y="0px"
    viewBox="0 -48 480 480"
    xml:space="preserve"
    :width="width"
    :height="height"
    :fill="fillColor"
    stroke="white"
    stroke-width="10"
  >
    <linearGradient id="a">
      <stop offset="0" :stop-color="stopColor1" />
      <stop offset="1" :stop-color="stopColor2" />
    </linearGradient>
    <linearGradient
      id="b"
      gradientUnits="userSpaceOnUse"
      x1="-16"
      x2="467.256"
      xlink:href="#a"
      y1="192"
      y2="192"
    />
    <linearGradient
      id="c"
      gradientUnits="userSpaceOnUse"
      x1="-16"
      x2="467.256"
      xlink:href="#a"
      y1="224"
      y2="224"
    />
    <linearGradient
      id="d"
      gradientUnits="userSpaceOnUse"
      x1="-16"
      x2="467.256"
      xlink:href="#a"
      y1="120"
      y2="120"
    />
    <linearGradient
      id="e"
      gradientUnits="userSpaceOnUse"
      x1="-16"
      x2="467.256"
      xlink:href="#a"
      y1="238.392"
      y2="238.392"
    />
    <path
      d="m472 64h-168v-56c0-4.417969-3.582031-8-8-8h-112c-4.417969 0-8 3.582031-8 8v56h-48v-24c0-4.417969-3.582031-8-8-8h-80c-4.417969 0-8 3.582031-8 8v24h-24c-4.417969 0-8 3.582031-8 8v304c0 4.417969 3.582031 8 8 8h464c4.417969 0 8-3.582031 8-8v-304c0-4.417969-3.582031-8-8-8zm-280-48h96v48h-96zm-144 32h64v16h-64zm416 224h-64v16h64v16h-64v16h64v16h-64v16h64v16h-448v-16h64v-16h-64v-16h64v-16h-64v-16h64v-16h-64v-192h448zm0 0"
      fill="url(#b)"
    />
    <path
      d="m144 224c0 53.019531 42.980469 96 96 96s96-42.980469 96-96-42.980469-96-96-96c-52.996094.058594-95.941406 43.003906-96 96zm176 0c0 44.183594-35.816406 80-80 80s-80-35.816406-80-80 35.816406-80 80-80c44.164062.046875 79.953125 35.835938 80 80zm0 0"
      fill="url(#c)"
    />
    <path
      d="m112 224c0 70.691406 57.308594 128 128 128s128-57.308594 128-128-57.308594-128-128-128c-70.65625.082031-127.917969 57.34375-128 128zm240 0c0 61.855469-50.144531 112-112 112s-112-50.144531-112-112 50.144531-112 112-112c61.828125.066406 111.933594 50.171875 112 112zm0 0"
      fill="url(#c)"
    />
    <path
      d="m416 144c13.253906 0 24-10.746094 24-24s-10.746094-24-24-24-24 10.746094-24 24 10.746094 24 24 24zm0-32c4.417969 0 8 3.582031 8 8s-3.582031 8-8 8-8-3.582031-8-8 3.582031-8 8-8zm0 0"
      fill="url(#d)"
    />
    <path
      d="m242.527344 287.59375c24.679687-8.234375 41.6875-21.824219 50.5625-40.417969 7.984375-18.355469 8.84375-39.03125 2.398437-57.984375l-14.992187 5.601563c4.953125 14.878906 4.292968 31.058593-1.855469 45.488281-8.691406 15.941406-23.597656 27.566406-41.175781 32.109375zm0 0"
      fill="url(#e)"
    />
  </svg>
</template>

<script>
export default {
  props: {
    active: {
      type: Boolean,
      default: false
    },

    width: {
      type: String,
      default: "512px"
    },

    height: {
      type: String,
      default: "512px"
    }
  },

  computed: {
    fillColor() {
      return this.active ? "#030C22" : "#a9a9a9";
    },

    stopColor1() {
      return this.active ? "#ff49d6" : "#a9a9a9";
    },

    stopColor2() {
      return this.active ? "#7bdfff" : "#a9a9a9";
    }
  }
};
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/components/showCapsule/icons/Camera.vue